import markdownToReact from '@sr/rich-text/markdown-to-react/src';
import { memo } from 'react';
import { Box } from 'theme-ui';

type Props = { markdown: string | undefined };

const Markdown = memo(function Markdown({ markdown }: Props) {
  if (markdown === undefined) return null;
  return (
    <Box
      sx={{
        // Apply basic styles to HTML frm markdown
        color: 'rgba(114, 118, 127, 1)',
        fontSize: 15,
        p: {
          mt: 0,
          mb: '1em',
        },
        ul: {
          mt: 0,
          mb: '1em',
          pl: 5,
        },
        em: {
          color: 'rgba(68, 72, 81, 1)',
        },
      }}
    >
      {markdownToReact(markdown)}
    </Box>
  );
});

export default Markdown;
